"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spotText = exports.hiddenCell = exports.hiddenRow = exports.legendColorIndicator = exports.legendRow = exports.spotTableCell = exports.tableBody = exports.spotTableRow = exports.strikeCell = exports.legendRowUnderneath = exports.strikeScrollTableRow = exports.strikeHeader = exports.strikeTable = void 0;

var _util = require("../../../util");

const strikeTable = () => ({
  flexGrow: 0,
  flexShrink: 0,
  minWidth: 116,
  width: '12%'
});

exports.strikeTable = strikeTable;

const strikeHeader = ({
  theme
}) => ({
  background: (0, _util.color)(theme, 'background.tan2')
});

exports.strikeHeader = strikeHeader;

const strikeScrollTableRow = ({
  theme
}) => ({
  height: 32,
  background: (0, _util.color)(theme, 'background.default')
});

exports.strikeScrollTableRow = strikeScrollTableRow;

const legendRowUnderneath = () => ({
  height: 48
});

exports.legendRowUnderneath = legendRowUnderneath;

const strikeCell = ({
  theme
}) => ({
  height: 48,
  verticalAlign: 'middle',
  background: (0, _util.color)(theme, 'background.tan2'),
  '&:active': {
    background: (0, _util.color)(theme, 'interactive.tan.active')
  },
  '&:hover': {
    background: (0, _util.color)(theme, 'interactive.tan.hover')
  }
});

exports.strikeCell = strikeCell;

const spotTableRow = ({
  cssProps,
  theme
}) => {
  const {
    callContainerWidth,
    middleContainerWidth
  } = cssProps;
  return {
    boxShadow: 'rgb(225 225 225) 1px 1px 0px 0px, rgb(225 225 225) 0px 0px 1px 1px',
    background: (0, _util.color)(theme, 'background.default'),
    zIndex: 2,
    position: 'absolute',
    height: 32,
    left: "-".concat(callContainerWidth, "px"),
    width: callContainerWidth + callContainerWidth + middleContainerWidth
  };
};

exports.spotTableRow = spotTableRow;

const tableBody = ({
  theme
}) => ({
  borderBottom: "1px solid ".concat((0, _util.color)(theme, 'ui3'))
});

exports.tableBody = tableBody;

const spotTableCell = () => ({
  height: 32,
  padding: 6,
  display: 'flex !important',
  width: '100%',
  justifyContent: 'center'
});

exports.spotTableCell = spotTableCell;

const legendRow = ({
  cssProps,
  theme
}) => {
  const {
    callContainerWidth,
    middleContainerWidth
  } = cssProps;
  return {
    borderBottom: "1px solid ".concat((0, _util.color)(theme, 'ui3')),
    borderLeft: "1px solid ".concat((0, _util.color)(theme, 'ui3')),
    borderRight: "1px solid ".concat((0, _util.color)(theme, 'ui3')),
    background: (0, _util.color)(theme, 'background.default'),
    height: 48,
    zIndex: 1,
    position: 'absolute',
    left: "-".concat(callContainerWidth, "px"),
    width: callContainerWidth + callContainerWidth + middleContainerWidth
  };
};

exports.legendRow = legendRow;

const legendColorIndicator = ({
  theme
}) => ({
  background: (0, _util.color)(theme, 'interactive.ui2.default'),
  borderRadius: (0, _util.spacing)(theme, 'xxxsmall'),
  boxShadow: (0, _util.boxShadow)(theme, [0, 0, 0, 1, 'ui3', true]),
  height: (0, _util.spacing)(theme, 'medium'),
  width: (0, _util.spacing)(theme, 'medium')
});

exports.legendColorIndicator = legendColorIndicator;

const hiddenRow = () => ({
  position: 'absolute'
});

exports.hiddenRow = hiddenRow;

const hiddenCell = () => ({
  padding: '0 !important'
});

exports.hiddenCell = hiddenCell;

const spotText = () => ({
  display: 'flex',
  alignItems: 'center'
});

exports.spotText = spotText;
//# sourceMappingURL=OptionChainMiddleTable.style.js.map